import React, { Component } from 'react';
import SelectMenu from '../SelectMenu/SelectMenu';

export const SELECT_IDENTIFIER = 'source';

export default class Select extends Component {
  render() {
    const { meta, source } = this.props;
    return (
      <div>
        <SelectMenu source={source} {...this.props} />
        {meta && meta.touched && meta.error && (
          <span className="input-error">{meta.error}</span>
        )}
      </div>
    );
  }
}
